import React from 'react';

export const TableHeader =(props)=> {
  // Expected ["Value 1",...,"Value N"]
  const mappingContents = props.contents.map((value) => <th scope="col"> {value} </th>);
  return (
      <tr>
        {mappingContents}
      </tr>
  );
}
